module.exports = __webpack_public_path__ + "static/img/goblet.ea5610d3.svg";